var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImprovedWorkforceProductivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 74.036 74.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-productivity",
    "data-name": "9-productivity",
    transform: "translate(0.599 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36795",
    "data-name": "Path 36795",
    d: "M72.563,21.3a1.136,1.136,0,0,0-1.094-.254L53.29,26.417a1.139,1.139,0,0,0-.483,1.9l3.042,3.042L39.884,47.324l-9.645-9.647a5.714,5.714,0,0,0-8.088.031L.3,61.248a1.139,1.139,0,1,0,1.67,1.55L23.792,39.29a3.424,3.424,0,0,1,4.835,0L39.078,49.741a1.173,1.173,0,0,0,1.611,0L58.267,32.163a1.139,1.139,0,0,0,0-1.611l-2.493-2.493L70.29,23.771,67.068,39.353,64.713,37A1.139,1.139,0,0,0,63.1,37L42.3,57.8a3.424,3.424,0,0,1-4.835,0L27.015,47.348a1.139,1.139,0,0,0-1.661.053L7.122,68.108a1.139,1.139,0,1,0,1.71,1.506l17.43-19.8,9.593,9.594a5.707,5.707,0,0,0,8.058,0L63.908,39.416l3.042,3.042a1.14,1.14,0,0,0,1.922-.575L72.907,22.37a1.141,1.141,0,0,0-.344-1.069Z",
    transform: "translate(0 2.93)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36796",
    "data-name": "Path 36796",
    d: "M17.14,56A1.14,1.14,0,0,0,16,57.14v6.837a1.14,1.14,0,0,0,2.279,0V57.14A1.14,1.14,0,0,0,17.14,56Z",
    transform: "translate(2.233 7.814)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36797",
    "data-name": "Path 36797",
    d: "M5.14,51.372a1.14,1.14,0,0,0,1.14-1.14V34.279h11.4v1.14a1.14,1.14,0,0,0,2.279,0V33.14A1.14,1.14,0,0,0,18.814,32H5.14A1.14,1.14,0,0,0,4,33.14V50.233A1.14,1.14,0,0,0,5.14,51.372Z",
    transform: "translate(0.558 4.465)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36798",
    "data-name": "Path 36798",
    d: "M47.14,48A1.14,1.14,0,0,0,46,49.14V65.093a1.14,1.14,0,0,0,2.279,0V49.14A1.14,1.14,0,0,0,47.14,48Z",
    transform: "translate(6.419 6.698)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36799",
    "data-name": "Path 36799",
    d: "M47.14,27.349a1.14,1.14,0,0,0,1.14-1.14V2.279h11.4V21.651a1.14,1.14,0,1,0,2.279,0V1.14A1.14,1.14,0,0,0,60.814,0H47.14A1.14,1.14,0,0,0,46,1.14v25.07A1.14,1.14,0,0,0,47.14,27.349Z",
    transform: "translate(6.419)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36800",
    "data-name": "Path 36800",
    d: "M59.14,42A1.14,1.14,0,0,0,58,43.14V65.93a1.14,1.14,0,0,0,2.279,0V43.14A1.14,1.14,0,0,0,59.14,42Z",
    transform: "translate(8.093 5.861)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36801",
    "data-name": "Path 36801",
    d: "M38.14,57A1.14,1.14,0,0,0,37,58.14v5.7a1.14,1.14,0,1,0,2.279,0v-5.7A1.14,1.14,0,0,0,38.14,57Z",
    transform: "translate(5.163 7.954)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36802",
    "data-name": "Path 36802",
    d: "M26.14,34.814a1.14,1.14,0,0,0,1.14-1.14v-11.4h11.4V40.512a1.14,1.14,0,0,0,2.279,0V21.14A1.14,1.14,0,0,0,39.814,20H26.14A1.14,1.14,0,0,0,25,21.14V33.674A1.14,1.14,0,0,0,26.14,34.814Z",
    transform: "translate(3.489 2.791)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36803",
    "data-name": "Path 36803",
    d: "M26.14,51A1.14,1.14,0,0,0,25,52.14V64.674a1.14,1.14,0,0,0,2.279,0V52.14A1.14,1.14,0,0,0,26.14,51Z",
    transform: "translate(3.489 7.117)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovedWorkforceProductivity);
export default __webpack_public_path__ + "static/media/improved-workforce-productivity.4a35a52d1bc6623c28d2fbc8a127c57e.svg";
export { ForwardRef as ReactComponent };